export const styles = {
  reportContainer: {
    p: { xs: 1, sm: 1, md: 0, lg: 0, xl: 0 },
    display: "flex",
    flexDirection: {
      xl: "row",
      md: "row",
      lg: "row",
      sm: "column",
      xs: "column",
    },
    gap: {
      xl: "0",
      md: "0",
      lg: "0",
      sm: "1rem",
      xs: "1rem",
    },
    justifyContent: "space-between",
    width: {
      xl: "1500px",
      md: "900px",
      lg: "1200px",
      sm: "100%",
      xs: "100%",
    },
    margin: "auto",
  },
  chartHeaderTitle: {
    bgcolor: "#6A2382",
    minHeight: "85px",
    color: "#fff",
    fontFamily: "poppins",
    display: "flex",
    alignItems: {
      xs: "start",
      sm: "center",
      md: "center",
      lg: "center",
      xl: "center",
    },
    px: {
      xs: 1,
      sm: 2,
      md: 2,
      lg: 2,
      xl: 3,
    },
    mb: {
      xs: 1,
      sm: 5,
      md: 5,
      lg: 5,
      xl: 5,
    },
    flexDirection: {
      xs: "column",
      sm: "row",
      md: "row",
      lg: "row",
      xl: "row",
    },
    justifyContent: {
      xs: "space-around",
      sm: "space-between",
      md: "space-between",
      lg: "space-between",
      xl: "space-between",
    },
    boxShadow: "2px 2px 10px 2px #0000004f",
    position: "sticky",
    top: 0,
    zIndex: 1000,
  },
  toggleBtn: {
    background: "#F8F8FF",
    py: {
      xs: 0.2,
      sm: 0.8,
      md: 0.8,
      lg: 0.8,
      xl: 0.8,
    },
    px: {
      xs: 0.2,
      sm: 1,
      md: 1,
      lg: 1,
      xl: 1,
    },
    gap: {
      xs: "0.2rem",
      sm: "1rem",
      md: "1rem",
      lg: "1rem",
      xl: "1rem",
    },
    button: {
      fontSize: {
        xs: "12px",
        sm: "14px",
      },
      padding: {
        xs: "5.5px",
        sm: 0.5,
      },
    },
    "& .MuiToggleButton-root": {
      border: "none",
      "&.Mui-selected": {
        background: "#6A2382",
        color: "#fff",
        borderRadius: "4px",
      },
    },
  },
  downloadBtn: {
    py: {
      xs: 0.5,
      sm: "16px",
      md: "10px",
      lg: "10px",
      xl: "10px",
    },
    px: {
      xs: 0.5,
      sm: "16px",
      md: 1.5,
      lg: 1.5,
      xl: 1.5,
    },
    minWidth: {
      xs: "auto",
      sm: "inherit",
    },
    ml: {
      xs: 0.2,
      sm: 2,
      md: 2,
      lg: 2,
      xl: 2,
    },
    background: "#F8F8FF",
    boxShadow: "none",
    color: "#6A2382",
    "&:hover": {
      borderColor: "#6A2382",
      color: "#6A2382",
      boxShadow: "none",
      svg: {
        fill: "#fff",
      },
    },
  },
  graphCard: {
    p: {
      xs: 1,
      md: 2,
      lg: 2,
      xl: 2,
    },
    mb: 3,
    boxShadow: "none",
    border: "1px solid #E7E7E7",
    borderRadius: "10px",
    overflow: "visible",
  },
  chartTitle: {
    display: "flex",
    justifyContent: "space-between",
    mb: 3,
    flexDirection: {
      xl: "row",
      md: "row",
      lg: "row",
      sm: "column",
      xs: "column",
    },
  },
  customDatePicker: {
    display: "flex",
    gap: 2,
    mt: 1,
    position: "absolute",
    background: "#fff",
    width: "100%",
    padding: "1rem",
    boxShadow: "0px 4px 8px rgb(0 0 0 / 25%)",
    zIndex: 999,
  },
};
